/**
 * @file
 * @author dailin01
 */
import Button from './button';
export default Button;